/* Platform-agnostic offer resolver and safe preview controller.
 * Offer eligibility reads only offer_id plus the central catalog.
 * Acquisition context is captured separately and is never an eligibility input.
 */
(function (root) {
  "use strict";
  if (root.BYLORO_OFFER_FLOW && root.BYLORO_OFFER_FLOW.catalog.indy_gift_v1.version === "1.5.9") return;

  const offerCartFetch = root.fetch && root.fetch.bind(root);
  const OFFER_CATALOG = {
  "indy_gift_v1": {
    "id": "indy_gift_v1",
    "version": "1.5.9",
    "enabled": true,
    "previewOnly": false,
    "mode": "production",
    "checkoutReady": true,
    "previewCartTestEnabled": true,
    "suppressAnnouncementText": ["CODE: 5OFF"],
    "suppressMarketingFormEmbed": true,
    "startsAt": "2026-10-08T12:10:00.000Z",
    "endsAt": "2026-10-15T12:10:00.000Z",
    "qualifying": {
      "productId": "9714591433033",
      "variantIds": [
        "52537172328777",
        "52537172361545",
        "52537172394313",
        "52537172427081",
        "52537172459849",
        "52537172492617",
        "52537172525385",
        "52537172558153",
        "52537172590921",
        "52537172623689",
        "52537172656457",
        "52537172689225",
        "52537172721993",
        "52537172754761",
        "52537172787529",
        "52537172820297",
        "52537172853065",
        "52537172885833",
        "52537172918601",
        "52537172951369",
        "52537172984137",
        "52537173016905",
        "52537173049673",
        "52537173082441",
        "52537173115209",
        "52537173147977",
        "52537173180745",
        "52537173213513",
        "52537173246281",
        "52537173279049"
      ],
      "personalization": {
        "propertyName": "Personalisatie",
        "label": { "nl": "Personaliseer je Indy", "en": "Personalize your Indy" },
        "placeholder": { "nl": "Naam, woord of datum", "en": "Name, word or date" }
      },
      "minimumQuantity": 1
    },
    "gifts": [
      {
        "key": "evy",
        "productId": "7722652172514",
        "label": {
          "nl": "Initial Evy",
          "en": "Initial Evy"
        },
        "imageUrl": "https://cdn.shopify.com/s/files/1/0614/3049/7506/files/BYLORO-CustommadeinitialEvyNecklace2.jpg?v=1762345164",
        "imageAlt": {
          "nl": "Initial Evy ketting",
          "en": "Initial Evy necklace"
        },
        "personalizationStatus": "cart_field_key_verified; campaign_order_unverified",
        "personalization": {
          "mode": "input",
          "propertyName": "Personalisatie",
          "label": { "nl": "Personaliseer Initial Evy", "en": "Personalize Initial Evy" },
          "placeholder": { "nl": "Voer een initiaal, cijfer of symbool in", "en": "Enter an initial, number or symbol" }
        },
        "variants": [
          {
            "id": "42807502209250",
            "options": {
              "Color": "Goud",
              "Make it a gift": "No thankyou"
            }
          },
          {
            "id": "42807502274786",
            "options": {
              "Color": "Zilver",
              "Make it a gift": "No thankyou"
            }
          },
          {
            "id": "42807502373090",
            "options": {
              "Color": "Rosé",
              "Make it a gift": "No thankyou"
            }
          }
        ],
        "selectionFields": [
          {
            "optionName": "Color",
            "label": {
              "nl": "Kleur",
              "en": "Color"
            },
            "placeholder": {
              "nl": "Kies een kleur",
              "en": "Choose a color"
            }
          }
        ],
        "leadTime": {
          "nl": "Custommade; wordt binnen 4 weken verzonden.",
          "en": "Custom-made; ships within 4 weeks."
        },
      },
      {
        "key": "jaloro",
        "productId": "8748034261321",
        "label": {
          "nl": "Initial J’aloro",
          "en": "Initial J’aloro"
        },
        "imageUrl": "https://cdn.shopify.com/s/files/1/0614/3049/7506/files/Hanger_1_6e32219d-8d60-49c9-a1c3-39190390ef48.jpg?v=1714070088",
        "imageAlt": {
          "nl": "Initial J’aloro ketting",
          "en": "Initial J’aloro necklace"
        },
        "personalizationStatus": "variant_letter_and_property_key_verified; campaign_order_unverified",
        "personalization": {
          "mode": "variant",
          "propertyName": "Personalisatie",
          "optionName": "Letter"
        },
        "variants": [
          {
            "id": "49028437016905",
            "options": {
              "Color": "Goud",
              "Letter": "A"
            }
          },
          {
            "id": "49033611510089",
            "options": {
              "Color": "Goud",
              "Letter": "B"
            }
          },
          {
            "id": "49033611542857",
            "options": {
              "Color": "Goud",
              "Letter": "C"
            }
          },
          {
            "id": "49033611575625",
            "options": {
              "Color": "Goud",
              "Letter": "D"
            }
          },
          {
            "id": "49033611608393",
            "options": {
              "Color": "Goud",
              "Letter": "E"
            }
          },
          {
            "id": "49033611641161",
            "options": {
              "Color": "Goud",
              "Letter": "F"
            }
          },
          {
            "id": "49033611673929",
            "options": {
              "Color": "Goud",
              "Letter": "G"
            }
          },
          {
            "id": "49033611706697",
            "options": {
              "Color": "Goud",
              "Letter": "H"
            }
          },
          {
            "id": "49033611739465",
            "options": {
              "Color": "Goud",
              "Letter": "I"
            }
          },
          {
            "id": "49033611772233",
            "options": {
              "Color": "Goud",
              "Letter": "J"
            }
          },
          {
            "id": "49033611805001",
            "options": {
              "Color": "Goud",
              "Letter": "K"
            }
          },
          {
            "id": "49033611837769",
            "options": {
              "Color": "Goud",
              "Letter": "L"
            }
          },
          {
            "id": "49033611870537",
            "options": {
              "Color": "Goud",
              "Letter": "M"
            }
          },
          {
            "id": "49033611903305",
            "options": {
              "Color": "Goud",
              "Letter": "N"
            }
          },
          {
            "id": "49033611936073",
            "options": {
              "Color": "Goud",
              "Letter": "O"
            }
          },
          {
            "id": "49033611968841",
            "options": {
              "Color": "Goud",
              "Letter": "P"
            }
          },
          {
            "id": "49033612001609",
            "options": {
              "Color": "Goud",
              "Letter": "Q"
            }
          },
          {
            "id": "49033612034377",
            "options": {
              "Color": "Goud",
              "Letter": "R"
            }
          },
          {
            "id": "49033612067145",
            "options": {
              "Color": "Goud",
              "Letter": "S"
            }
          },
          {
            "id": "49033612099913",
            "options": {
              "Color": "Goud",
              "Letter": "T"
            }
          },
          {
            "id": "49033612132681",
            "options": {
              "Color": "Goud",
              "Letter": "U"
            }
          },
          {
            "id": "49033612165449",
            "options": {
              "Color": "Goud",
              "Letter": "V"
            }
          },
          {
            "id": "49033612198217",
            "options": {
              "Color": "Goud",
              "Letter": "W"
            }
          },
          {
            "id": "49033612230985",
            "options": {
              "Color": "Goud",
              "Letter": "X"
            }
          },
          {
            "id": "49033612263753",
            "options": {
              "Color": "Goud",
              "Letter": "Y"
            }
          },
          {
            "id": "49033612296521",
            "options": {
              "Color": "Goud",
              "Letter": "Z"
            }
          },
          {
            "id": "49028437344585",
            "options": {
              "Color": "Zilver",
              "Letter": "A"
            }
          },
          {
            "id": "49033612362057",
            "options": {
              "Color": "Zilver",
              "Letter": "B"
            }
          },
          {
            "id": "49033612394825",
            "options": {
              "Color": "Zilver",
              "Letter": "C"
            }
          },
          {
            "id": "49033612427593",
            "options": {
              "Color": "Zilver",
              "Letter": "D"
            }
          },
          {
            "id": "49033612460361",
            "options": {
              "Color": "Zilver",
              "Letter": "E"
            }
          },
          {
            "id": "49033612493129",
            "options": {
              "Color": "Zilver",
              "Letter": "F"
            }
          },
          {
            "id": "49033612525897",
            "options": {
              "Color": "Zilver",
              "Letter": "G"
            }
          },
          {
            "id": "49033612558665",
            "options": {
              "Color": "Zilver",
              "Letter": "H"
            }
          },
          {
            "id": "49033612591433",
            "options": {
              "Color": "Zilver",
              "Letter": "I"
            }
          },
          {
            "id": "49033612624201",
            "options": {
              "Color": "Zilver",
              "Letter": "J"
            }
          },
          {
            "id": "49033612656969",
            "options": {
              "Color": "Zilver",
              "Letter": "K"
            }
          },
          {
            "id": "49033612689737",
            "options": {
              "Color": "Zilver",
              "Letter": "L"
            }
          },
          {
            "id": "49033612722505",
            "options": {
              "Color": "Zilver",
              "Letter": "M"
            }
          },
          {
            "id": "49033612755273",
            "options": {
              "Color": "Zilver",
              "Letter": "N"
            }
          },
          {
            "id": "49033612788041",
            "options": {
              "Color": "Zilver",
              "Letter": "O"
            }
          },
          {
            "id": "49033612820809",
            "options": {
              "Color": "Zilver",
              "Letter": "P"
            }
          },
          {
            "id": "49033612853577",
            "options": {
              "Color": "Zilver",
              "Letter": "Q"
            }
          },
          {
            "id": "49033612886345",
            "options": {
              "Color": "Zilver",
              "Letter": "R"
            }
          },
          {
            "id": "49033612919113",
            "options": {
              "Color": "Zilver",
              "Letter": "S"
            }
          },
          {
            "id": "49033612951881",
            "options": {
              "Color": "Zilver",
              "Letter": "T"
            }
          },
          {
            "id": "49033612984649",
            "options": {
              "Color": "Zilver",
              "Letter": "U"
            }
          },
          {
            "id": "49033613017417",
            "options": {
              "Color": "Zilver",
              "Letter": "V"
            }
          },
          {
            "id": "49033613050185",
            "options": {
              "Color": "Zilver",
              "Letter": "W"
            }
          },
          {
            "id": "49033613082953",
            "options": {
              "Color": "Zilver",
              "Letter": "X"
            }
          },
          {
            "id": "49033613115721",
            "options": {
              "Color": "Zilver",
              "Letter": "Y"
            }
          },
          {
            "id": "49033613148489",
            "options": {
              "Color": "Zilver",
              "Letter": "Z"
            }
          }
        ],
        "selectionFields": [
          {
            "optionName": "Color",
            "label": {
              "nl": "Kleur",
              "en": "Color"
            },
            "placeholder": {
              "nl": "Kies een kleur",
              "en": "Choose a color"
            }
          },
          {
            "optionName": "Letter",
            "label": {
              "nl": "Initiaal",
              "en": "Initial"
            },
            "placeholder": {
              "nl": "Kies een letter",
              "en": "Choose a letter"
            }
          }
        ],
        "leadTime": {
          "nl": "Custommade; productietijd 4 weken.",
          "en": "Custom-made; production time is 4 weeks."
        },
      }
    ],
    "limits": {
      "giftQuantityPerOrder": 1
    },
    "discount": {
        "type": "discountos_line_attribute",
        "production": {
            "enabled": true,
            "engine": "discountos",
            "title": "Gratis cadeau bij Indy",
            "discountId": "gid://shopify/DiscountAutomaticNode/1874065555785",
            "startsAt": "2026-10-08T12:10:00.000Z",
            "endsAt": "2026-10-15T12:10:00.000Z",
            "variants": {}
        },
        "legacyCodes": [
            "BYLORO-INDY-GIFT-C90B7425532B4C78",
            "BYLORO-QA-INDY-250925-7K4M",
            "BYLORO-QA-V-E06770C7520FA4DE8029",
            "BYLORO-QA-V-0CF54F0760D19B4C4EEF",
            "BYLORO-QA-V-DFCF7683471427B7439E"
        ]
    },
    "shipping": {
      "countryCode": "NL",
      "serverRuleStatus": "existing_standard_rate_verified"
    },
    "customerText": {
      "nl": {
        "title": "Kies je gratis sieraad",
        "giftHeading": "Kies je gratis sieraad",
        "cardBadge": "Gratis bij jouw Indy",
        "shipping": "Gratis standaardverzending in Nederland.",
        "limit": "Eén gratis cadeau bij jouw Indy.",
        "skipGift": "Ik sla het cadeau liever over",
        "giftCartNotice": "Zonder Indy in je bestelling is dit cadeau niet gratis. Je kunt het tegen de getoonde prijs houden of uit je winkelwagen verwijderen.",
        "cta": "Voeg Indy + gratis cadeau toe",
        "ctaWithoutGift": "Voeg Indy toe",
        "leadTime": "Custommade · verzending binnen 4 weken",
        "addingCta": "Toevoegen…",
        "selectionStatus": "Gekozen cadeau: ",
        "giftOptionsHeading": "Personaliseer je cadeau",
        "personalizationConflict": "Je Indy-personalisaties verschillen. Maak beide invoervelden gelijk en probeer opnieuw.",
        "cartConfirmed": "Je gekozen cadeau is gratis. Controleer hieronder je personalisaties.",
        "cartUnconfirmed": "Je cadeau is nog niet gratis. Wijzig je cadeau en probeer opnieuw.",
        "promotionConflict": "Deze cadeauactie kan niet worden gecombineerd met een andere korting. Verwijder de andere korting om je gratis sieraad te kiezen.",
        "editGift": "Wijzig je cadeau",
        "replaceGift": "Vervang cadeau in winkelwagen",
        "missingIndyPersonalization": "Vul eerst de personalisatie van je Indy in.",
        "missingGiftSelection": "Kies je cadeau en vul de cadeauopties in.",
        "missingGiftPersonalization": "Vul de personalisatie van Initial Evy in.",
        "alreadyAdded": "Deze Indy-cadeauactie staat al in je winkelwagen. Bekijk je winkelwagen om verder te gaan.",
        "existingOfferItems": "Je winkelwagen bevat al een Indy, Evy of J’aloro die voor deze aanbieding in aanmerking komt. We hebben niets toegevoegd. Rond af zonder deze actie of verwijder dat artikel eerst.",
        "failed": "Toevoegen is niet gelukt. Je bestaande winkelwagen is behouden; controleer je invoer en probeer daarna opnieuw.",
        "partialFailure": "Toevoegen is niet volledig gelukt. Controleer eerst je winkelwagen en voeg de actie niet opnieuw toe.",
        "previewOnlyError": "Deze aanbieding is niet beschikbaar.",
        "expired": "Deze aanbieding is verlopen. Er is niets toegevoegd."
      },
      "en": {
        "title": "Choose your free jewelry",
        "giftHeading": "Choose your necklace gift",
        "cardBadge": "Free with your Indy",
        "shipping": "Free standard shipping in the Netherlands.",
        "limit": "One free gift with your Indy.",
        "skipGift": "I prefer to skip the gift",
        "giftCartNotice": "Without an Indy in your order, this gift is not free. Keep it at the price shown or remove it from your cart.",
        "cta": "Add Indy + free gift",
        "ctaWithoutGift": "Add Indy",
        "leadTime": "Custom-made · ships within 4 weeks",
        "addingCta": "Adding…",
        "selectionStatus": "Gift selected: ",
        "giftOptionsHeading": "Personalize your gift",
        "personalizationConflict": "Your Indy personalizations differ. Make both fields match and try again.",
        "cartConfirmed": "Your chosen gift is free. Check your personalizations below.",
        "cartUnconfirmed": "Your gift is not free yet. Change your gift and try again.",
        "promotionConflict": "This gift offer cannot be combined with another discount. Remove the other discount to choose your free jewelry.",
        "editGift": "Change your gift",
        "replaceGift": "Replace gift in cart",
        "missingIndyPersonalization": "Enter your Indy personalization first.",
        "missingGiftSelection": "Choose your gift and complete its options.",
        "missingGiftPersonalization": "Enter the Initial Evy personalization.",
        "alreadyAdded": "This Indy gift offer is already in your cart. Open your cart to continue.",
        "existingOfferItems": "Your cart already contains an Indy, Evy or J’aloro that could qualify for this offer. Nothing was added. Continue without this offer or remove that item first.",
        "failed": "We could not add the offer. Your existing cart is preserved; check your input and try again.",
        "partialFailure": "The offer could not be added completely. Check your cart before continuing; do not add the offer again.",
        "previewOnlyError": "This offer is not available.",
        "expired": "This offer has expired. Nothing was added."
      }
    },
    "reporting": {
      "status": "not_connected",
      "fields": [
        "offer_id",
        "offer_version",
        "source",
        "campaign",
        "adset",
        "adgroup",
        "creative",
        "content_id",
        "gift_product",
        "gift_variant",
        "shopify_order_id"
      ]
    }
  }
  };
  const mountedDocuments = new WeakSet();
  const giftDrafts = new WeakMap();
  const nativePurchaseMarkup = new WeakMap();
  const nativePersonalizationCopies = new WeakMap();
  const indyPersonalizationControls = new WeakMap();

  function normalizeId(value) {
    return String(value || "").split("/").pop();
  }

  function paramsFrom(value) {
    if (value instanceof URLSearchParams) return value;
    return new URLSearchParams(value || "");
  }

  function isWithinWindow(offer, now) {
    if (offer.startsAt) {
      const start = Date.parse(offer.startsAt);
      if (!Number.isFinite(start) || now < start) return false;
    }
    if (offer.endsAt) {
      const end = Date.parse(offer.endsAt);
      if (!Number.isFinite(end) || now >= end) return false;
    }
    return true;
  }

  function resolveOffer(query, productId, variantId, now) {
    const params = paramsFrom(query);
    const id = params.get("offer");
    const offer = id && OFFER_CATALOG[id];
    if (!offer || !offer.enabled) return null;
    if (!isWithinWindow(offer, now === undefined ? Date.now() : now)) return null;
    if (normalizeId(productId) !== offer.qualifying.productId) return null;
    if (!offer.qualifying.variantIds.includes(normalizeId(variantId))) return null;
    return offer;
  }

  function safeToken(value) {
    const token = String(value || "").trim();
    if (!token || token.length > 120 || !/^[A-Za-z0-9_.:-]+$/.test(token)) return "";
    return token;
  }

  function firstParam(params, keys) {
    for (const key of keys) {
      const value = safeToken(params.get(key));
      if (value) return value;
    }
    return "";
  }

  function getAttributionContext(query) {
    const params = paramsFrom(query);
    return {
      source: firstParam(params, ["utm_source", "source"]),
      campaign: firstParam(params, ["utm_campaign", "campaign", "campaignid"]),
      adset: firstParam(params, ["adset", "utm_adset"]),
      adgroup: firstParam(params, ["adgroup", "adgroupid", "ad_group_id"]),
      creative: firstParam(params, ["creative", "creative_id"]),
      contentId: firstParam(params, ["content_id", "utm_content"])
    };
  }

  function buildOrderReport(offer, attribution, shopifyOrderId, gift) {
    if (!offer) return null;
    return {
      offer_id: offer.id,
      offer_version: offer.version,
      source: attribution.source || "",
      campaign: attribution.campaign || "",
      adset: attribution.adset || "",
      adgroup: attribution.adgroup || "",
      creative: attribution.creative || "",
      content_id: attribution.contentId || "",
      gift_product: gift && gift.productId ? normalizeId(gift.productId) : "",
      gift_variant: gift && gift.variantId ? normalizeId(gift.variantId) : "",
      shopify_order_id: shopifyOrderId ? String(shopifyOrderId) : ""
    };
  }

  function buildOfferUrl(baseUrl, offerId, attribution) {
    if (!OFFER_CATALOG[offerId]) throw new Error("Unknown offer ID");
    const url = new URL(baseUrl, root.location && root.location.href ? root.location.href : "https://byloro.nl/");
    url.searchParams.set("offer", offerId);
    for (const [inputKey, urlKey] of [["source", "source"], ["campaign", "campaign"], ["adset", "adset"], ["adgroup", "adgroup"], ["creative", "creative"], ["contentId", "content_id"]]) {
      const value = safeToken(attribution && attribution[inputKey]);
      if (value) url.searchParams.set(urlKey, value);
    }
    return url.toString();
  }

  function selectedVariantId(doc, formId, fallback) {
    const form = doc.getElementById(formId);
    const input = form && form.querySelector('[name="id"]');
    return input && input.value ? input.value : fallback;
  }

  function localized(value, locale) {
    if (value && typeof value === "object") {
      const language = String(locale || "nl").toLowerCase().split("-")[0];
      return value[language] || value.nl || value.en || "";
    }
    return value || "";
  }

  function getGiftFieldOptions(gift, optionName) {
    return [...new Set((gift && gift.variants || []).map(variant => variant.options && variant.options[optionName]).filter(Boolean))];
  }

  function resolveGiftVariant(gift, selections) {
    if (!gift || !Array.isArray(gift.variants)) return null;
    const fields = gift.selectionFields || [];
    if (!fields.length || !fields.every(field => selections && selections[field.optionName])) return null;
    const match = gift.variants.find(variant => fields.every(field => variant.options && variant.options[field.optionName] === selections[field.optionName]));
    return match ? match.id : null;
  }

  function buildCartItems(offer, qualifyingVariantId, indyProperties, giftKey, giftVariantId, giftPersonalization, flowId, locale) {
    if (!offer || !offer.previewCartTestEnabled) throw new Error("Offer is not enabled for preview cart testing");
    const indyVariant = normalizeId(qualifyingVariantId);
    if (!offer.qualifying.variantIds.includes(indyVariant)) throw new Error("Indy variant is not eligible for this offer");
    const cleanIndyProperties = {};
    Object.entries(indyProperties || {}).forEach(([key, value]) => {
      if (typeof value === "string" && value.trim() && !key.startsWith("_")) cleanIndyProperties[key] = value;
    });
    const indyPropertyName = offer.qualifying.personalization && offer.qualifying.personalization.propertyName;
    if (!indyPropertyName || !cleanIndyProperties[indyPropertyName] || !cleanIndyProperties[indyPropertyName].trim()) {
      throw new Error("Indy personalization is required");
    }

    const marker = {
      _byloro_offer_id: offer.id,
      _byloro_offer_version: offer.version,
      _byloro_flow_id: String(flowId)
    };
    const items = [{
      id: indyVariant,
      quantity: 1,
      properties: { ...cleanIndyProperties, ...marker, _byloro_campaign_line: "indy", _byloro_offer_role: "indy" }
    }];

    if (!giftKey || giftKey === "none") return items;
    const gift = (offer.gifts || []).find(candidate => candidate.key === giftKey);
    if (!gift) throw new Error("Gift is not in the offer catalog");
    const variant = gift.variants.find(candidate => normalizeId(candidate.id) === normalizeId(giftVariantId));
    if (!variant) throw new Error("Gift variant is not allowed by the offer");
    const discount = discountForVariant(offer, variant.id);
    if (!discount) throw new Error("No approved discount mapping for this gift variant");
    const mapping = gift.personalization || {};
    let personalization = "";
    if (mapping.mode === "variant") personalization = variant.options && variant.options[mapping.optionName] || "";
    else if (mapping.mode === "input") personalization = String(giftPersonalization || "");
    if (!personalization.trim()) throw new Error("Gift personalization is required");

    const giftProperties = {
      [mapping.propertyName || "Personalisatie"]: personalization,
      ...marker,
      _byloro_campaign_line: "gift",
      _byloro_offer_role: "gift"
    };
    if (discountMode(offer).engine === "discountos") giftProperties._byloro_offer = offer.id;
    else giftProperties._byloro_discount_code = discount.code;

    items.push({
      id: normalizeId(variant.id),
      quantity: 1,
      properties: giftProperties
    });
    return items;
  }

  function clearOwnedNativePersonalizationCopies(form) {
    if (!form) return;
    for (const mirror of form.querySelectorAll("[data-byloro-native-personalization]")) mirror.disabled = true;
    for (const field of form.elements) {
      if (!nativePersonalizationCopies.has(field)) continue;
      if (field.value === nativePersonalizationCopies.get(field)) field.value = "";
      nativePersonalizationCopies.delete(field);
    }
  }

  function readProductProperties(form, FormDataConstructor) {
    clearOwnedNativePersonalizationCopies(form);
    const properties = {};
    if (!form || !FormDataConstructor) return properties;
    for (const [name, value] of new FormDataConstructor(form).entries()) {
      const match = /^properties\[([^\]]+)\]$/.exec(name);
      if (match && typeof value === "string" && value.trim()) properties[match[1]] = value;
    }
    return properties;
  }

  function readProductPropertyValues(form, FormDataConstructor, propertyName) {
    if (!form || !FormDataConstructor || !propertyName) return [];
    const expectedName = "properties[" + propertyName + "]";
    return [...new FormDataConstructor(form).entries()]
      .filter(([name, value]) => name === expectedName && typeof value === "string" && value.trim())
      .map(([, value]) => value);
  }

  function isRenderedVisibleField(field) {
    if (!field || field.disabled) return false;
    if (typeof field.getClientRects === "function") {
      const rects = field.getClientRects();
      if (!rects || rects.length === 0) return false;
      const view = field.ownerDocument && field.ownerDocument.defaultView;
      const style = view && typeof view.getComputedStyle === "function" ? view.getComputedStyle(field) : null;
      return !style || (style.display !== "none" && style.visibility !== "hidden" && style.visibility !== "collapse");
    }
    return field.offsetParent !== null;
  }

  function retainedIndyPersonalizationControls(component) {
    if (!component) return {};
    const retained = indyPersonalizationControls.get(component);
    if (retained) return retained;
    const wrapper = component.querySelector("[data-offer-indy-personalization-wrap]");
    const input = component.querySelector("[data-offer-indy-personalization]");
    const label = component.querySelector("[data-offer-indy-personalization-label]");
    const controls = { wrapper, input, label };
    if (wrapper && input) indyPersonalizationControls.set(component, controls);
    return controls;
  }

  function findExternalProductPropertyField(component, form, propertyName) {
    if (!component || !form || !propertyName) return null;
    const section = form.closest(".shopify-section") || form.parentElement;
    if (!section) return null;
    const expectedName = "properties[" + propertyName + "]";
    const fallback = retainedIndyPersonalizationControls(component).input;
    return [...section.querySelectorAll("[name]")].find(field =>
      field.name === expectedName &&
      field !== fallback &&
      !component.contains(field) &&
      isRenderedVisibleField(field)
    ) || null;
  }

  function findCanonicalProductPropertyField(component, form, propertyName) {
    const external = findExternalProductPropertyField(component, form, propertyName);
    if (external) return external;
    const fallback = retainedIndyPersonalizationControls(component).input;
    return form && [...form.elements].find(field =>
      field !== fallback && field.name === "properties[" + propertyName + "]" && isRenderedVisibleField(field)
    ) || null;
  }

  function resolveIndyPersonalization(component, form, offer, doc, FormDataConstructor) {
    clearOwnedNativePersonalizationCopies(form);
    const propertyName = offer && offer.qualifying && offer.qualifying.personalization && offer.qualifying.personalization.propertyName;
    if (!propertyName) return { propertyName: "", field: null, value: "", conflict: false };
    let field = findCanonicalProductPropertyField(component, form, propertyName);
    if (!field) {
      const fallback = retainedIndyPersonalizationControls(component).input;
      if (isRenderedVisibleField(fallback)) field = fallback;
    }
    const value = field && typeof field.value === "string" ? field.value : "";
    const serializedValues = readProductPropertyValues(form, FormDataConstructor || (doc.defaultView && doc.defaultView.FormData), propertyName);
    const meaningfulSerializedValues = serializedValues.filter(serializedValue => serializedValue.trim());
    const distinctSerializedValues = [...new Set(meaningfulSerializedValues)];
    const conflict = distinctSerializedValues.length > 1 || distinctSerializedValues.some(serializedValue => serializedValue !== value);
    return { propertyName, field, value, conflict };
  }

  function showIndyPersonalizationConflict(component, offer, doc) {
    const { wrapper, input } = retainedIndyPersonalizationControls(component);
    const locale = component.dataset.locale || doc.documentElement.lang || "nl";
    if (wrapper) wrapper.hidden = false;
    if (input) { input.disabled = false; input.required = true; }
    component.dataset.personalizationConflict = "true";
    setOfferStatus(component, localized(offer.customerText, locale).personalizationConflict, true);
  }

  function syncIndyPersonalization(component, offer, doc) {
    const { wrapper, input, label } = retainedIndyPersonalizationControls(component);
    if (!wrapper || !input) return;

    const mapping = offer && offer.qualifying && offer.qualifying.personalization;
    const propertyName = mapping && mapping.propertyName;
    const locale = component.dataset.locale || doc.documentElement.lang || "nl";

    if (propertyName) input.name = "properties[" + propertyName + "]";
    if (label) label.textContent = localized(mapping && mapping.label, locale);
    input.placeholder = localized(mapping && mapping.placeholder, locale);

    if (!offer || !propertyName) {
      wrapper.hidden = true;
      input.disabled = true;
      input.required = false;
      return;
    }

    const form = doc.getElementById(component.dataset.formId || "");
    const canonical = findCanonicalProductPropertyField(component, form, propertyName);
    if (canonical) {
      const fallbackValue = String(input.value || "");
      const outcome = personalizationTransfer(fallbackValue, String(canonical.value || ""));
      if (outcome.conflict) {
        showIndyPersonalizationConflict(component, offer, doc);
        return;
      }
      if (outcome.transfer) {
        canonical.value = fallbackValue;
        const EventConstructor = doc.defaultView.Event;
        if (EventConstructor) {
          canonical.dispatchEvent(new EventConstructor("input", { bubbles: true }));
          canonical.dispatchEvent(new EventConstructor("change", { bubbles: true }));
        }
      }
      if (outcome.transfer && String(canonical.value || "") !== fallbackValue) {
        wrapper.hidden = false;
        input.disabled = false;
        input.required = true;
        return;
      }
      input.value = "";
      delete component.dataset.personalizationConflict;
      wrapper.hidden = true;
      input.disabled = true;
      input.required = false;
      return;
    }

    wrapper.hidden = false;
    delete component.dataset.personalizationConflict;
    input.disabled = false;
    input.required = true;
  }

  function readGiftSelections(details) {
    const selections = {};
    if (!details) return selections;
    details.querySelectorAll("[data-offer-gift-field]").forEach(select => {
      if (select.value) selections[select.name] = select.value;
    });
    return selections;
  }

  function readGiftPersonalization(details) {
    const field = details && details.querySelector("[data-offer-personalization]");
    return field && typeof field.value === "string" ? field.value : "";
  }

  function saveGiftDraft(rootNode) {
    const details = rootNode && rootNode.querySelector("[data-offer-gift-details]");
    const key = details && details.dataset.giftKey;
    if (!key) return;
    const drafts = giftDrafts.get(rootNode) || {};
    drafts[key] = { ...readGiftSelections(details), personalization: readGiftPersonalization(details) };
    giftDrafts.set(rootNode, drafts);
  }

  function getGiftDraft(rootNode, key) {
    return (giftDrafts.get(rootNode) || {})[key] || {};
  }

  function suppressConflictingAnnouncements(offer, doc) {
    const patterns = offer.suppressAnnouncementText || [];
    (doc.querySelectorAll("[data-byloro-suppressed-announcement]") || []).forEach(node => {
      if (node.dataset.byloroWasHidden !== "true") node.hidden = false;
      delete node.dataset.byloroSuppressedAnnouncement;
      delete node.dataset.byloroWasHidden;
    });
    patterns.forEach(pattern => {
      const target = [...doc.querySelectorAll("p, [role='status'], [role='banner']")].find(node =>
        node.children.length === 0 && (node.textContent || "").toLowerCase().includes(String(pattern).toLowerCase())
      );
      if (!target) return;
      const section = target.closest(".shopify-section--countdown-condensed") || target.closest("section") || target;
      section.dataset.byloroWasHidden = String(section.hidden);
      section.dataset.byloroSuppressedAnnouncement = "";
      section.hidden = true;
    });
  }

  function updateOfferPromotionalSuppressions(offer, doc) {
    const html = doc.documentElement;
    const active = Boolean(offer && offer.suppressMarketingFormEmbed);
    if (!active) {
      html.removeAttribute("data-byloro-offer-suppress-forms");
      return;
    }
    html.setAttribute("data-byloro-offer-suppress-forms", "true");
    if (doc.getElementById("byloro-offer-suppress-forms")) return;
    const style = doc.createElement("style");
    style.id = "byloro-offer-suppress-forms";
    style.textContent = 'html[data-byloro-offer-suppress-forms="true"] shopify-forms-embed { display: none !important; }';
    doc.head.append(style);
  }

  function cartRoot(doc) {
    const routes = doc.defaultView.Shopify && doc.defaultView.Shopify.routes;
    return routes && routes.root ? routes.root : "/";
  }

  async function getCart(doc) {
    const response = await doc.defaultView.fetch(cartRoot(doc) + "cart.js", {
      credentials: "same-origin",
      headers: { Accept: "application/json" },
      signal: doc.defaultView.AbortSignal && doc.defaultView.AbortSignal.timeout(10000)
    });
    if (!response.ok) throw new Error("Could not read cart");
    return response.json();
  }

  function isPreviewTheme(offer, doc) {
    const theme = doc.defaultView.Shopify && doc.defaultView.Shopify.theme;
    return Boolean(theme && String(theme.id) === String(offer.previewThemeId) && String(theme.role).toLowerCase() === "unpublished");
  }

  function discountMode(offer) {
    return offer.discount && offer.discount[offer.mode || "preview"] || { variants: {} };
  }

  function discountForVariant(offer, variantId) {
    const mode = discountMode(offer);
    const mapping = mode.variants || {};
    const normalizedId = normalizeId(variantId);
    const allowed = (offer.gifts || []).some(gift => gift.variants.some(v => normalizeId(v.id) === normalizedId));
    if (mode.engine === "discountos") return allowed && mode.discountId ? { discountId: mode.discountId } : null;
    return allowed && mapping[normalizedId] && mapping[normalizedId].code ? mapping[normalizedId] : null;
  }

  function allowedEnvironment(offer, doc) {
    if (offer.mode === "production") return Boolean(discountMode(offer).enabled);
    return isPreviewTheme(offer, doc);
  }

  function personalizationTransfer(fallback, canonical) {
    return {
      conflict: Boolean(fallback.trim() && canonical.trim() && fallback !== canonical),
      transfer: Boolean(fallback.trim() && !canonical.trim())
    };
  }

  function campaignRole(item, offer) {
    const p = item.properties || {};
    return p._byloro_offer_id === offer.id ? (p._byloro_offer_role || p._byloro_campaign_line || "") : "";
  }

  function campaignState(cart, offer) {
    const items = cart.items || [];
    const gifts = items.filter(item => campaignRole(item, offer) === "gift");
    const indy = items.filter(item => campaignRole(item, offer) === "indy");
    const qualifying = items.filter(item => offer.qualifying.variantIds.includes(normalizeId(item.id)));
    const attributes = cart.attributes || {};
    return { gifts, indy, qualifying, active: gifts.length > 0 || indy.length > 0 || attributes._byloro_offer_id === offer.id };
  }

  function knownCampaignCodes(offer) {
    return new Set([...(offer.discount.legacyCodes || []), ...["preview", "production"].flatMap(mode =>
      Object.values(offer.discount[mode] && offer.discount[mode].variants || {}).map(mapping => mapping.code)
    )].filter(Boolean).map(code => code.toUpperCase()));
  }

  function cartCodes(cart) {
    const explicit = (cart.discount_codes || []).map(entry => entry.code).filter(Boolean);
    const applications = [...(cart.cart_level_discount_applications || []), ...(cart.items || []).flatMap(item =>
      (item.line_level_discount_allocations || []).map(allocation => allocation.discount_application || {})
    )];
    return [...new Set([...explicit, ...applications.filter(application => application.type === "discount_code")
      .map(application => application.title).filter(Boolean)])];
  }

  function ordinaryCodes(cart, offer) {
    const known = knownCampaignCodes(offer);
    return cartCodes(cart).filter(code => !known.has(code.toUpperCase()));
  }

  function hasIncompatiblePromotion(cart, offer) {
    if (ordinaryCodes(cart, offer).length || (cart.cart_level_discount_applications || []).some(a => Number(a.total_allocated_amount) > 0)) return true;
    const gift = campaignState(cart, offer).gifts[0];
    if (gift && verifyGiftAllocation(cart, offer, gift.id).valid) return false;
    return (cart.items || []).some(item => (item.line_level_discount_allocations || []).some(a => Number(a.amount) > 0));
  }

  function verifyGiftAllocation(cart, offer, giftVariantId) {
    const mapping = discountForVariant(offer, giftVariantId);
    if (!mapping) return { valid: false, reason: "mapping" };
    const mode = discountMode(offer);
    if (mode.engine === "discountos") {
      const items = cart.items || [];
      const marked = items.filter(item => campaignRole(item, offer) === "gift" || item.properties?._byloro_offer === offer.id);
      const target = marked[0];
      if (marked.length !== 1 || !target || normalizeId(target.id) !== normalizeId(giftVariantId) ||
          target.properties._byloro_offer !== offer.id || target.properties._byloro_offer_id !== offer.id ||
          target.properties._byloro_offer_role !== "gift" || Number(target.quantity) !== 1 ||
          !campaignState(cart, offer).qualifying.some(item => Number(item.quantity) >= offer.qualifying.minimumQuantity)) {
        return { valid: false, reason: "eligibility" };
      }
      const allocations = (target.line_level_discount_allocations || []).filter(a => Number(a.amount) > 0);
      const unitPrice = Number(target.original_price);
      const campaignAmount = allocations.reduce((sum, a) => sum + Number(a.amount), 0);
      if (items.some(item => item !== target && (item.line_level_discount_allocations || []).some(a => Number(a.amount) > 0))) {
        return { valid: false, reason: "wrong_line" };
      }
      const totalOriginal = items.reduce((sum, item) => sum + Number(item.original_line_price), 0);
      const totalFinal = items.reduce((sum, item) => sum + Number(item.final_line_price), 0);
      const valid = unitPrice > 0 && allocations.length === 1 && campaignAmount === unitPrice &&
        Number(target.original_line_price) === unitPrice && Number(target.final_price) === 0 && Number(target.final_line_price) === 0 &&
        !(cart.cart_level_discount_applications || []).length && Number(cart.total_discount) === unitPrice &&
        Number(cart.total_price) === totalOriginal - unitPrice && totalFinal === Number(cart.total_price);
      return { valid, reason: valid ? "" : "allocation", freeUnits: valid ? 1 : 0, discountAmount: campaignAmount };
    }
    let campaignAmount = 0;
    const expected = (cart.items || []).filter(item => normalizeId(item.id) === normalizeId(giftVariantId));
    if (!expected.length || !campaignState(cart, offer).qualifying.length) return { valid: false, reason: "eligibility" };
    const unitPrices = new Set(expected.map(item => Number(item.original_price)));
    if (unitPrices.size !== 1) return { valid: false, reason: "price" };
    const unitPrice = Number(expected[0].original_price);
    for (const item of cart.items || []) {
      for (const allocation of item.line_level_discount_allocations || []) {
        if (Number(allocation.amount || 0) === 0) continue;
        const application = allocation.discount_application || {};
        const title = String(application.title || "").toUpperCase();
        if (title !== mapping.code.toUpperCase()) return { valid: false, reason: "unexpected_discount" };
        if (normalizeId(item.id) !== normalizeId(giftVariantId)) return { valid: false, reason: "wrong_variant" };
        campaignAmount += Number(allocation.amount || 0);
      }
    }
    const sumOriginal = expected.reduce((sum, item) => sum + Number(item.original_line_price), 0);
    const sumFinal = expected.reduce((sum, item) => sum + Number(item.final_line_price), 0);
    const cartDiscounts = cart.cart_level_discount_applications || [];
    const totalOriginal = (cart.items || []).reduce((sum, item) => sum + Number(item.original_line_price), 0);
    const totalFinal = (cart.items || []).reduce((sum, item) => sum + Number(item.final_line_price), 0);
    const valid = unitPrice > 0 && campaignAmount === unitPrice && sumOriginal - sumFinal === unitPrice &&
      !cartDiscounts.length && Number(cart.total_discount) === unitPrice && Number(cart.total_price) === totalOriginal - unitPrice &&
      totalFinal === Number(cart.total_price);
    return { valid, reason: valid ? "" : "allocation", freeUnits: valid ? 1 : 0, discountAmount: campaignAmount };
  }

  function lineSignature(item) {
    const properties = Object.entries(item.properties || {}).sort(([a], [b]) => a.localeCompare(b));
    return JSON.stringify([normalizeId(item.id), item.selling_plan_allocation && item.selling_plan_allocation.selling_plan.id || null, properties]);
  }

  function sameExistingCartLines(before, after) {
    const totals = items => {
      const map = new Map();
      for (const item of items || []) map.set(lineSignature(item), (map.get(lineSignature(item)) || 0) + item.quantity);
      return map;
    };
    const current = totals(after.items);
    return [...totals(before.items)].every(([signature, quantity]) => current.get(signature) === quantity);
  }

  async function cartRequest(doc, path, body) {
    const proof = doc.querySelector("[data-byloro-preview-cart-proof]");
    if (proof) proof.dataset.requestPhase = path + ":pending";
    const request = new doc.defaultView.Request(new URL(cartRoot(doc) + path, doc.defaultView.location.href), {
      method: "POST", credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body),
      signal: doc.defaultView.AbortSignal && doc.defaultView.AbortSignal.timeout(10000)
    });
    const response = await offerCartFetch(request);
    if (proof) proof.dataset.requestPhase = path + ":" + response.status;
    if (!response.ok) throw new Error("Shopify cart update failed");
    return response.json();
  }

  async function changeMarkedGift(doc, offer, flowId, quantity) {
    const current = await getCart(doc);
    const item = campaignState(current, offer).gifts.find(line => line.properties._byloro_flow_id === flowId);
    if (item) await cartRequest(doc, "cart/change.js", { id: item.key, quantity });
    return getCart(doc);
  }

  async function applyCampaignCode(doc, offer, variantId) {
    const cart = await getCart(doc);
    const mapping = variantId && discountForVariant(offer, variantId);
    if (variantId && !mapping) throw new Error("Missing approved discount mapping");
    if (discountMode(offer).engine === "discountos") {
      const codes = ordinaryCodes(cart, offer);
      await cartRequest(doc, "cart/update.js", {
        discount: codes.join(","),
        attributes: {
          _byloro_offer_id: mapping ? offer.id : "",
          _byloro_gift_variant: mapping ? normalizeId(variantId) : "",
          _byloro_discount_code: ""
        }
      });
      const after = await getCart(doc);
      publishPreviewCartProof(doc, offer, after);
      if (!mapping && cartCodes(after).some(code => knownCampaignCodes(offer).has(code.toUpperCase()))) throw new Error("Campaign discount cleanup failed");
      if (!mapping && codes.some(code => !cartCodes(after).some(value => value.toUpperCase() === code.toUpperCase()))) throw new Error("Ordinary discount was not preserved");
      return after;
    }
    const codes = mapping ? [mapping.code] : ordinaryCodes(cart, offer);
    await cartRequest(doc, "cart/update.js", {
      discount: codes.join(","),
      attributes: {
        _byloro_offer_id: mapping ? offer.id : "",
        _byloro_gift_variant: mapping ? normalizeId(variantId) : "",
        _byloro_discount_code: mapping ? mapping.code : ""
      }
    });
    const after = await getCart(doc);
    publishPreviewCartProof(doc, offer, after);
    if (!mapping && cartCodes(after).some(code => knownCampaignCodes(offer).has(code.toUpperCase()))) throw new Error("Campaign discount cleanup failed");
    if (!mapping && codes.some(code => !cartCodes(after).some(value => value.toUpperCase() === code.toUpperCase()))) throw new Error("Ordinary discount was not preserved");
    return after;
  }

  function publishPreviewCartProof(doc, offer, cart) {
    if (offer.mode !== "preview" || !isPreviewTheme(offer, doc)) return;
    let node = doc.querySelector("[data-byloro-preview-cart-proof]");
    if (!node) {
      node = doc.createElement("script"); node.type = "application/json";
      node.dataset.byloroPreviewCartProof = ""; doc.body.append(node);
    }
    node.textContent = JSON.stringify({
      offer_version: offer.version, mode: offer.mode, observed_at: new Date().toISOString(),
      discount_codes: cart.discount_codes || null,
      attributes: Object.fromEntries(Object.entries(cart.attributes || {}).filter(([key]) => key.startsWith("_byloro_"))),
      total_price: cart.total_price, total_discount: cart.total_discount,
      items: (cart.items || []).map(item => ({
        id: item.id, key: item.key, quantity: item.quantity, properties: item.properties,
        original_price: item.original_price, original_line_price: item.original_line_price,
        final_line_price: item.final_line_price, line_level_discount_allocations: item.line_level_discount_allocations
      }))
    });
  }

  const busyComponents = new WeakSet();
  const cartControllers = new WeakMap();
  const cartQueues = new WeakMap();

  function campaignEditUrl(doc, offer) {
    return cartRoot(doc) + "products/custommade-indy-necklace?offer=" + encodeURIComponent(offer.id) + "&view=indy-gift-preview";
  }

  function routeMarkedGiftLinks(doc, offer, cart) {
    const giftKeys = new Set(campaignState(cart, offer).gifts.map(item => item.key));
    for (const anchor of doc.querySelectorAll('a[href*="/cart/change"]')) {
      const href = anchor.getAttribute("href") || "";
      const key = new URLSearchParams(href.split("?")[1] || "").get("id");
      if (!giftKeys.has(key)) continue;
      const row = anchor.closest("tr") || anchor.closest("line-item");
      if (!row) continue;
      for (const link of row.querySelectorAll('line-item a[href*="/products/"], .line-item-info a[href*="/products/"]')) {
        link.href = campaignEditUrl(doc, offer);
      }
    }
  }

  function withCartLock(doc, work) {
    const run = () => {
      const locks = doc.defaultView.navigator && doc.defaultView.navigator.locks;
      if (!locks || typeof locks.request !== "function") throw new Error("Je browser kan de cadeauwijziging niet veilig verwerken. Open deze aanbieding in een actuele browser en probeer opnieuw.");
      return locks.request("byloro-offer-cart", work);
    };
    const previous = cartQueues.get(doc) || Promise.resolve();
    const next = previous.catch(() => {}).then(run);
    cartQueues.set(doc, next);
    return next;
  }

  async function reconcileCampaignCart(doc, offer) {
    let cart = await getCart(doc);
    let state = campaignState(cart, offer);
    if (!state.active) return { cart, active: false, changed: false };
    publishPreviewCartProof(doc, offer, cart);
    if (!allowedEnvironment(offer, doc)) throw new Error("Campaign is unavailable in this theme");
    let changed = false;
    if (!state.qualifying.length) {
      for (const gift of state.gifts) {
        cart = await changeMarkedGift(doc, offer, gift.properties._byloro_flow_id, 0);
        changed = true;
      }
      cart = await applyCampaignCode(doc, offer, null);
      return { cart, active: false, changed: true };
    }
    if (!state.gifts.length) {
      if ((cart.attributes || {})._byloro_offer_id || cartCodes(cart).some(code => knownCampaignCodes(offer).has(code.toUpperCase()))) {
        cart = await applyCampaignCode(doc, offer, null);
        changed = true;
      }
      return { cart, active: false, changed };
    }
    if (state.gifts.length !== 1) throw new Error("Multiple campaign gifts: review the cart before checkout");
    const gift = state.gifts[0];
    const mapping = discountForVariant(offer, gift.id);
    if (discountMode(offer).engine === "discountos") {
      const markedTarget = Boolean(mapping && gift.properties._byloro_offer === offer.id &&
        gift.properties._byloro_offer_id === offer.id && gift.properties._byloro_offer_role === "gift" &&
        gift.properties._byloro_flow_id);
      if (!markedTarget) {
        await changeMarkedGift(doc, offer, gift.properties._byloro_flow_id, 0);
        cart = await applyCampaignCode(doc, offer, null);
        return { cart, active: false, changed: true };
      }
      if (gift.quantity !== 1) throw new Error("Campaign gift quantity must be exactly one");
      const attributes = cart.attributes || {};
      if (attributes._byloro_offer_id !== offer.id ||
          attributes._byloro_gift_variant !== normalizeId(gift.id) ||
          attributes._byloro_discount_code) {
        cart = await applyCampaignCode(doc, offer, gift.id);
        changed = true;
      }
      if (!verifyGiftAllocation(cart, offer, gift.id).valid) throw new Error("Shopify has not confirmed exactly one free gift");
      return { cart, active: true, changed };
    }
    if (!mapping || gift.properties._byloro_discount_code !== mapping.code) {
      await changeMarkedGift(doc, offer, gift.properties._byloro_flow_id, 0);
      cart = await applyCampaignCode(doc, offer, null);
      return { cart, active: false, changed: true };
    }
    if (gift.quantity !== 1) {
      cart = await changeMarkedGift(doc, offer, gift.properties._byloro_flow_id, 1);
      changed = true;
    }
    const codes = cartCodes(cart);
    if (codes.length !== 1 || codes[0].toUpperCase() !== mapping.code.toUpperCase() || (cart.attributes || {})._byloro_discount_code !== mapping.code) {
      cart = await applyCampaignCode(doc, offer, gift.id);
      changed = true;
    }
    if (!verifyGiftAllocation(cart, offer, gift.id).valid) throw new Error("Shopify has not confirmed exactly one free gift");
    return { cart, active: true, changed };
  }

  function mountCartLifecycle(doc, offer) {
    if (cartControllers.has(doc)) return cartControllers.get(doc);
    const win = doc.defaultView;
    let active = true, bypass = false, request = null, latest = null;
    let recoveredNotice = win.sessionStorage.getItem("byloro-campaign-recovered") === offer.id;
    if (recoveredNotice) win.sessionStorage.removeItem("byloro-campaign-recovered");
    const status = () => {
      let node = doc.querySelector("[data-byloro-cart-status]");
      if (!node) {
        node = doc.createElement("div");
        node.dataset.byloroCartStatus = "";
        node.setAttribute("role", "status");
        node.style.cssText = "padding:1rem;margin:1rem 0;border:1px solid currentColor";
        const isCartPage = win.themeVariables?.settings.pageType === "cart";
        const host = isCartPage
          ? doc.querySelector("main .cart-recap") || doc.querySelector("main")
          : doc.querySelector("cart-drawer .cart-recap") || doc.querySelector("cart-drawer") || doc.querySelector("main");
        if (host) host.prepend(node);
      }
      return node;
    };
    const refresh = () => {
      if (win.themeVariables && win.themeVariables.settings.pageType === "cart") win.location.reload();
      else doc.dispatchEvent(new win.CustomEvent("cart:refresh", { bubbles: true }));
    };
    const check = () => {
      if (request) return request;
      request = withCartLock(doc, () => reconcileCampaignCart(doc, offer)).then(result => {
        latest = result; active = result.active;
        updateOfferPromotionalSuppressions(active ? offer : null, doc);
        if (!doc.querySelectorAll("[data-byloro-offer-flow]").length && win.themeVariables && win.themeVariables.settings.pageType === "cart") {
          suppressConflictingAnnouncements(active ? offer : { suppressAnnouncementText: [] }, doc);
        }
        if (active) routeMarkedGiftLinks(doc, offer, result.cart);
        const node = status();
        node.replaceChildren();
        node.hidden = !active;
        if (active) recoveredNotice = false;
        if (!active && recoveredNotice) {
          node.hidden = false;
          node.textContent = localized(offer.customerText, doc.documentElement.lang).promotionConflict;
        }
        if (active) {
          const text = doc.createElement("p");
          text.textContent = localized(offer.customerText, doc.documentElement.lang).cartConfirmed;
          node.append(text);
          const edit = doc.createElement("a");
          edit.textContent = localized(offer.customerText, doc.documentElement.lang).editGift;
          edit.href = campaignEditUrl(doc, offer);
          node.append(edit);
        }
        for (const component of doc.querySelectorAll("[data-byloro-offer-flow]")) {
          component.dataset.campaignEdit = campaignState(result.cart, offer).indy.length ? "true" : "";
          const button = offerPurchaseButton(component, doc);
          if (button && component.dataset.campaignEdit) button.textContent = localized(offer.customerText, doc.documentElement.lang).replaceGift;
        }
        if (result.changed) refresh();
        return result;
      }).catch(async error => {
        const restored = await withCartLock(doc, () => restoreCheckoutBaseline(doc, offer)).catch(() => false);
        const node = status(); node.hidden = false;
        const copy = localized(offer.customerText, doc.documentElement.lang);
        node.textContent = restored ? copy.promotionConflict : copy.partialFailure;
        if (restored) {
          recoveredNotice = true;
          win.sessionStorage.setItem("byloro-campaign-recovered", offer.id);
          refresh();
        }
        throw error;
      }).finally(() => { request = null; });
      return request;
    };
    const checkQuietly = () => { check().catch(() => {}); };
    doc.addEventListener("cart:change", checkQuietly);
    win.addEventListener("pageshow", checkQuietly);
    win.addEventListener("storage", event => { if (event.key === "byloro-offer-cart-updated") checkQuietly(); });
    const beforeCheckout = event => {
      const target = event.target.closest && event.target.closest('[name="checkout"], a[href*="/checkout"]');
      const formCheckout = event.type === "submit" && event.submitter && event.submitter.name === "checkout";
      if (bypass || !active || (!target && !formCheckout)) return;
      event.preventDefault(); event.stopImmediatePropagation();
      check().then(result => {
        if (result.changed) return;
        bypass = true;
        if (event.type === "submit") event.target.requestSubmit(event.submitter);
        else if (target.tagName === "A") win.location.assign(target.href);
        else target.click();
        bypass = false;
      }).catch(() => {});
    };
    doc.addEventListener("click", beforeCheckout, true);
    doc.addEventListener("submit", beforeCheckout, true);
    const controller = { check, get latest() { return latest; } };
    cartControllers.set(doc, controller);
    checkQuietly();
    return controller;
  }

  function createFlowId(win) {
    if (win.crypto && typeof win.crypto.randomUUID === "function") return win.crypto.randomUUID();
    return "flow-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 12);
  }

  function baselineKey(offer) { return "byloro-campaign-recovery-" + offer.id; }

  function readCheckoutBaseline(doc, offer) {
    try { return JSON.parse(doc.defaultView.sessionStorage.getItem(baselineKey(offer)) || "null"); }
    catch (_) { return null; }
  }

  function saveCheckoutBaseline(doc, offer, before, flowId) {
    const existing = readCheckoutBaseline(doc, offer);
    const baseline = existing && campaignState(before, offer).active ? existing : {
      cart: { items: before.items, attributes: before.attributes, discount_codes: before.discount_codes,
        cart_level_discount_applications: before.cart_level_discount_applications,
        total_price: before.total_price, total_discount: before.total_discount },
      flowIds: []
    };
    baseline.flowIds = [...new Set([...baseline.flowIds, flowId])];
    doc.defaultView.sessionStorage.setItem(baselineKey(offer), JSON.stringify(baseline));
  }

  async function restoreCheckoutBaseline(doc, offer) {
    const baseline = readCheckoutBaseline(doc, offer);
    if (!baseline) return false;
    for (const flowId of baseline.flowIds) {
      if (!await removeFlowLines(doc, flowId)) return false;
    }
    const restored = await restoreCampaignCart(doc, offer, baseline.cart, "", null, false);
    if (restored) doc.defaultView.sessionStorage.removeItem(baselineKey(offer));
    return restored;
  }

  function cartHasOffer(cart, offerId) {
    return (cart.items || []).some(item => item.properties && item.properties._byloro_offer_id === offerId);
  }

  function cartHasConflictingOfferLines(cart, offer) {
    const qualifyingVariants = new Set((offer.qualifying && offer.qualifying.variantIds || []).map(normalizeId));
    const giftVariants = new Set((offer.gifts || []).flatMap(gift => (gift.variants || []).map(variant => normalizeId(variant.id))));
    return (cart.items || []).some(item => qualifyingVariants.has(normalizeId(item.id)) || giftVariants.has(normalizeId(item.id)));
  }

  async function removeFlowLines(doc, flowId) {
    try {
      const cart = await getCart(doc);
      const owned = (cart.items || []).filter(item => item.properties && item.properties._byloro_flow_id === flowId);
      for (const item of owned) {
        const current = await getCart(doc);
        const fresh = (current.items || []).find(line => lineSignature(line) === lineSignature(item));
        if (fresh) await cartRequest(doc, "cart/change.js", { id: fresh.key, quantity: 0 });
      }
      const after = await getCart(doc);
      return !(after.items || []).some(item => item.properties && item.properties._byloro_flow_id === flowId);
    } catch (_) {
      return false;
    }
  }

  function cartRecoveryMatches(before, recovered, offer) {
    if (!sameExistingCartLines(before, recovered) || !sameExistingCartLines(recovered, before)) return false;
    for (const key of ["_byloro_offer_id", "_byloro_gift_variant", "_byloro_discount_code"]) {
      if (((before.attributes || {})[key] || "") !== ((recovered.attributes || {})[key] || "")) return false;
    }
    const codes = cart => cartCodes(cart).map(code => code.toUpperCase()).sort().join(",");
    if (codes(before) !== codes(recovered) || before.total_price !== recovered.total_price || before.total_discount !== recovered.total_discount) return false;
    const oldGift = campaignState(before, offer).gifts[0];
    return !oldGift || !verifyGiftAllocation(before, offer, oldGift.id).valid || verifyGiftAllocation(recovered, offer, oldGift.id).valid;
  }

  async function restoreCampaignCart(doc, offer, before, flowId, oldGift, touched) {
    try {
      if (touched && !await removeFlowLines(doc, flowId)) return false;
      if (oldGift && touched) {
        const current = await getCart(doc);
        if (!(current.items || []).some(item => lineSignature(item) === lineSignature(oldGift))) {
          await cartRequest(doc, "cart/add.js", { items: [{ id: oldGift.id, quantity: oldGift.quantity, properties: oldGift.properties }] });
        }
      }
      await cartRequest(doc, "cart/update.js", {
        discount: cartCodes(before).join(","),
        attributes: {
          _byloro_offer_id: (before.attributes || {})._byloro_offer_id || "",
          _byloro_gift_variant: (before.attributes || {})._byloro_gift_variant || "",
          _byloro_discount_code: (before.attributes || {})._byloro_discount_code || ""
        }
      });
      const recovered = await getCart(doc);
      publishPreviewCartProof(doc, offer, recovered);
      return cartRecoveryMatches(before, recovered, offer);
    } catch (_) { return false; }
  }

  function setOfferStatus(component, message, isError) {
    const status = component.querySelector("[data-offer-status]");
    if (!status) return;
    status.textContent = message || "";
    status.dataset.state = isError ? "error" : "info";
  }

  function clearGiftInputStatus(component, copy) {
    const status = component.querySelector("[data-offer-status]");
    if (status && status.dataset.state === "error" &&
        [copy.missingGiftSelection, copy.missingGiftPersonalization].includes(status.textContent)) {
      setOfferStatus(component, "", false);
    }
  }

  function offerPurchaseButton(component, doc) {
    const form = doc.getElementById(component.dataset.formId || "");
    return form && form.querySelector('button[type="submit"]');
  }

  async function addOfferToCart(component, doc) {
    if (busyComponents.has(component)) return;
    busyComponents.add(component);
    const button = offerPurchaseButton(component, doc);
    const offer = OFFER_CATALOG[component.dataset.offerId || ""];
    const locale = component.dataset.locale || doc.documentElement.lang || "nl";
    const copy = localized(offer && offer.customerText, locale) || {};
    const originalLabel = button && button.textContent;
    if (button) { button.disabled = true; button.setAttribute("aria-busy", "true"); button.textContent = copy.addingCta; }
    try {
      if (!offer || !offer.enabled || !allowedEnvironment(offer, doc)) throw new Error(copy.previewOnlyError);
      if (!isWithinWindow(offer, Date.now()) || !isWithinWindow(discountMode(offer), Date.now())) throw new Error(copy.expired);
      const form = doc.getElementById(component.dataset.formId || "");
      if (!form) throw new Error(copy.failed);
      syncIndyPersonalization(component, offer, doc);
      if (component.dataset.personalizationConflict) throw new Error(copy.personalizationConflict);
      const checked = component.querySelector("[data-offer-gift-list] input[type='radio']:checked");
      if (!checked) throw new Error(copy.missingGiftSelection);
      const giftKey = checked.value;
      const gift = (offer.gifts || []).find(candidate => candidate.key === giftKey);
      const details = component.querySelector("[data-offer-gift-details]");
      const giftVariantId = details && details.dataset.giftVariantId;
      const giftPersonalization = readGiftPersonalization(details);
      if (gift && (!giftVariantId || !discountForVariant(offer, giftVariantId))) throw new Error(copy.missingGiftSelection);
      if (gift && gift.personalization.mode === "input" && !giftPersonalization.trim()) throw new Error(copy.missingGiftPersonalization);
      await withCartLock(doc, async () => {
        const before = await getCart(doc);
        const state = campaignState(before, offer);
        if (gift && hasIncompatiblePromotion(before, offer)) {
          publishPreviewCartProof(doc, offer, before);
          throw new Error(copy.promotionConflict);
        }
        if (state.gifts.length > 1) throw new Error(copy.cartUnconfirmed);
        const existingIndy = state.indy.find(line => offer.qualifying.variantIds.includes(normalizeId(line.id)));
        const editing = Boolean(existingIndy && state.qualifying.length);
        if (!editing) {
          syncIndyPersonalization(component, offer, doc);
          if (component.dataset.personalizationConflict) throw new Error(copy.personalizationConflict);
        }
        const indyVariantId = editing ? normalizeId(existingIndy.id) : selectedVariantId(doc, component.dataset.formId, component.dataset.variantId);
        let indyProperties = editing ? existingIndy.properties : readProductProperties(form, doc.defaultView.FormData);
        const propertyName = offer.qualifying.personalization.propertyName;
        if (!editing) {
          const resolved = resolveIndyPersonalization(component, form, offer, doc, doc.defaultView.FormData);
          if (resolved.conflict) {
            showIndyPersonalizationConflict(component, offer, doc);
            throw new Error(copy.personalizationConflict);
          }
          if (resolved.value.trim()) indyProperties[propertyName] = resolved.value;
          else delete indyProperties[propertyName];
        }
        if (!editing && typeof form.reportValidity === "function" && !form.reportValidity()) throw new Error(copy.missingIndyPersonalization);
        if (!indyProperties[propertyName] || !indyProperties[propertyName].trim()) throw new Error(copy.missingIndyPersonalization);
        const flowId = createFlowId(doc.defaultView);
        const items = buildCartItems(offer, indyVariantId, indyProperties, giftKey, giftVariantId, giftPersonalization, flowId, locale);
        if (!editing) {
          const quantity = Number(new doc.defaultView.FormData(form).get("quantity") || 1);
          if (!Number.isSafeInteger(quantity) || quantity < 1) throw new Error(copy.failed);
          items[0].quantity = quantity;
          const section = form.closest(".shopify-section");
          const packaging = section && section.querySelector('byloro-gift-packaging[data-product-form-id="' + CSS.escape(form.getAttribute('id')) + '"]');
          if (packaging && packaging.querySelector("[data-gift-packaging-checkbox]")?.checked) {
            items.push({ id: normalizeId(packaging.dataset.giftVariantId), quantity: 1, properties: { _byloro_flow_id: flowId } });
          }
        }
        const oldGift = state.gifts[0];
        const preserved = { ...before, items: (before.items || []).filter(item => item !== oldGift) };
        let touched = false;
        try {
          if (gift) saveCheckoutBaseline(doc, offer, before, flowId);
          if (oldGift) {
            touched = true;
            await changeMarkedGift(doc, offer, oldGift.properties._byloro_flow_id, 0);
          }
          if (state.active) await applyCampaignCode(doc, offer, null);
          const addedItems = editing ? items.filter(item => campaignRole(item, offer) === "gift") : items;
          if (addedItems.length) {
            touched = true;
            await cartRequest(doc, "cart/add.js", { items: addedItems });
          }
          let after = await getCart(doc);
          if (!sameExistingCartLines(preserved, after)) throw new Error(copy.partialFailure);
          for (const expected of addedItems) {
            const actual = (after.items || []).find(item => lineSignature(item) === lineSignature(expected));
            if (!actual || actual.quantity !== expected.quantity) throw new Error(copy.partialFailure);
          }
          if (gift) {
            after = await applyCampaignCode(doc, offer, giftVariantId);
            if (!verifyGiftAllocation(after, offer, giftVariantId).valid) throw new Error(copy.promotionConflict);
          } else after = await applyCampaignCode(doc, offer, null);
          if (!sameExistingCartLines(preserved, after)) throw new Error(copy.partialFailure);
          try { doc.defaultView.localStorage.setItem("byloro-offer-cart-updated", String(Date.now())); } catch (_) {}
          doc.defaultView.location.assign(cartRoot(doc) + "cart");
        } catch (error) {
          const restored = await restoreCampaignCart(doc, offer, before, flowId, oldGift, touched);
          throw new Error(restored ? error.message : copy.partialFailure);
        }
      });
    } catch (error) {
      const message = Object.values(copy).includes(error.message) ? error.message : copy.failed;
      setOfferStatus(component, message, true);
      let field;
      if (message === copy.missingIndyPersonalization) field = [...doc.querySelectorAll('[name="properties[Personalisatie]"]')].find(field => isRenderedVisibleField(field));
      else if (message === copy.missingGiftPersonalization) field = component.querySelector("[data-offer-personalization]");
      else if (message === copy.missingGiftSelection) field = component.querySelector("[data-offer-gift-field]:invalid") || component.querySelector("[data-offer-gift-list] input");
      if (field) { field.scrollIntoView({ block: "center", behavior: "smooth" }); field.focus({ preventScroll: true }); }
    } finally {
      busyComponents.delete(component);
      if (button) { button.disabled = false; button.removeAttribute("aria-busy"); button.textContent = originalLabel || copy.cta; }
    }
  }

  function updateSelectionStatus(rootNode, gift, copy, locale, selections) {
    const status = rootNode.querySelector("[data-offer-selection-status]");
    if (!status) return;
    const label = gift ? localized(gift.label, locale) : localized(copy.skipGift, locale);
    const fields = gift ? (gift.selectionFields || []) : [];
    const values = fields.map(field => {
      const value = selections && selections[field.optionName];
      return value ? localized(field.label, locale) + ": " + value : "";
    }).filter(Boolean);
    status.textContent = localized(copy.selectionStatus, locale) + label + (values.length ? " — " + values.join(", ") : "");
  }

  function renderGiftDetails(rootNode, gift, offer, copy, locale, doc, selectedValues) {
    const details = rootNode.querySelector("[data-offer-gift-details]");
    if (!details) return;
    details.replaceChildren();
    if (!gift) {
      details.hidden = true;
      delete details.dataset.giftKey;
      delete details.dataset.giftVariantId;
      updateSelectionStatus(rootNode, null, copy, locale, {});
      return;
    }

    gift = { ...gift, variants: gift.variants.filter(variant => discountForVariant(offer, variant.id)) };
    details.hidden = false;
    details.dataset.giftKey = gift.key;
    const heading = doc.createElement("h3");
    heading.className = "byloro-offer-flow__fields-heading";
    heading.textContent = localized(copy.giftOptionsHeading, locale);


    (gift.selectionFields || []).forEach(field => {
      const label = doc.createElement("label");
      label.className = "byloro-offer-flow__field";
      label.textContent = localized(field.label, locale);
      const select = doc.createElement("select");
      select.name = field.optionName;
      select.required = true;
      select.dataset.offerGiftField = "";
      const placeholder = doc.createElement("option");
      placeholder.value = "";
      placeholder.disabled = true;
      placeholder.selected = !selectedValues || !selectedValues[field.optionName];
      placeholder.textContent = localized(field.placeholder, locale);
      select.append(placeholder);

      getGiftFieldOptions(gift, field.optionName).forEach(value => {
        const option = doc.createElement("option");
        option.value = value;
        option.textContent = value;
        option.selected = Boolean(selectedValues && selectedValues[field.optionName] === value);
        select.append(option);
      });

      select.addEventListener("change", () => {
        clearGiftInputStatus(rootNode, copy);
        const selections = readGiftSelections(details);
        const variantId = resolveGiftVariant(gift, selections);
        if (variantId) details.dataset.giftVariantId = variantId;
        else delete details.dataset.giftVariantId;
        saveGiftDraft(rootNode);
        updateSelectionStatus(rootNode, gift, copy, locale, selections);
      });
      label.append(select);
      details.append(label);
    });

    const personalization = gift.personalization || {};
    if (personalization.mode === "input") {
      const label = doc.createElement("label");
      label.className = "byloro-offer-flow__field";
      label.textContent = localized(personalization.label, locale);
      const input = doc.createElement("textarea");
      input.name = "gift[" + (personalization.propertyName || "Personalisatie") + "]";
      input.rows = 2;
      input.required = true;
      input.dataset.offerPersonalization = "";
      input.placeholder = localized(personalization.placeholder, locale);
      input.value = selectedValues && selectedValues.personalization || "";
      input.addEventListener("input", () => {
        clearGiftInputStatus(rootNode, copy);
        saveGiftDraft(rootNode);
      });
      label.append(input);
      details.append(label);
    }


    const selections = readGiftSelections(details);
    const variantId = resolveGiftVariant(gift, selections);
    if (variantId) details.dataset.giftVariantId = variantId;
    else delete details.dataset.giftVariantId;
    updateSelectionStatus(rootNode, gift, copy, locale, selections);
  }

  function renderOffer(rootNode, offer, doc) {
    const nativeButton = offerPurchaseButton(rootNode, doc);
    if (nativeButton && !nativePurchaseMarkup.has(nativeButton)) nativePurchaseMarkup.set(nativeButton, nativeButton.innerHTML);
    const locale = rootNode.dataset.locale || doc.documentElement.lang || "nl";
    const copy = localized(offer.customerText, locale) || {};
    const putText = (selector, value) => {
      const node = rootNode.querySelector(selector);
      if (node) node.textContent = localized(value, locale);
    };

    putText("[data-offer-title]", copy.title);
    putText("[data-offer-gift-heading]", copy.giftHeading);
    putText("[data-offer-shipping]", copy.shipping);
    putText("[data-offer-limit]", copy.limit);
    putText("[data-offer-lead-time]", copy.leadTime);
    putText("[data-offer-button]", rootNode.dataset.campaignEdit ? copy.replaceGift : copy.cta);

    const list = rootNode.querySelector("[data-offer-gift-list]");
    const details = rootNode.querySelector("[data-offer-gift-details]");
    if (!list) return;
    list.setAttribute("aria-label", localized(copy.giftHeading, locale));
    saveGiftDraft(rootNode);
    const selectedValue = list.querySelector('input[type="radio"]:checked')?.value || "";
    const priorGiftKey = details && details.dataset.giftKey || "";
    const priorSelections = readGiftSelections(details);
    priorSelections.personalization = readGiftPersonalization(details);
    list.replaceChildren();
    const name = "byloro-gift-" + offer.id + "-" + rootNode.dataset.productId;

    const appendChoice = (key, gift, label, imageUrl, imageAlt) => {
      const card = doc.createElement("label");
      card.className = "byloro-offer-flow__card";
      const input = doc.createElement("input");
      input.type = "radio";
      input.name = name;
      input.value = key;
      input.checked = key === selectedValue;
      input.dataset.giftLabel = label;
      const copyNode = doc.createElement("span");
      copyNode.className = "byloro-offer-flow__card-copy";
      const strong = doc.createElement("strong");
      strong.textContent = label;
      if (!gift) card.classList.add("byloro-offer-flow__card--skip");
      copyNode.append(strong);
      card.append(input);
      if (imageUrl && imageUrl.toLowerCase().startsWith("https://")) {
        const image = doc.createElement("img");
        image.className = "byloro-offer-flow__image";
        image.src = imageUrl;
        image.alt = imageAlt;
        image.loading = "lazy";
        card.append(image);
      }
      card.append(copyNode);
      input.addEventListener("change", () => {
        clearGiftInputStatus(rootNode, copy);
        saveGiftDraft(rootNode);
        const savedValues = gift ? getGiftDraft(rootNode, key) : {};
        renderGiftDetails(rootNode, gift, offer, copy, locale, doc, savedValues);
        const action = offerPurchaseButton(rootNode, doc);
        if (action) action.textContent = rootNode.dataset.campaignEdit ? copy.replaceGift : gift ? copy.cta : copy.ctaWithoutGift;
      });
      list.append(card);
    };

    (offer.gifts || []).filter(gift => gift.variants.some(v => discountForVariant(offer, v.id))).forEach(gift => {
      appendChoice(gift.key, gift, localized(gift.label, locale), "", "");
    });

    const selected = list.querySelector('input[type="radio"]:checked');
    if (selected) {
      const selectedGift = offer.gifts.find(gift => gift.key === selected.value) || null;
      const savedValues = selectedGift
        ? (selectedGift.key === priorGiftKey ? priorSelections : getGiftDraft(rootNode, selectedGift.key))
        : {};
      renderGiftDetails(rootNode, selectedGift, offer, copy, locale, doc, savedValues);
    } else if (details) {
      details.replaceChildren();
      details.hidden = true;
      delete details.dataset.giftKey;
      delete details.dataset.giftVariantId;
    }
    const button = offerPurchaseButton(rootNode, doc);
    if (button) {
      button.disabled = false;
      button.removeAttribute("aria-disabled");
    }
    if (button) button.textContent = rootNode.dataset.campaignEdit ? copy.replaceGift : copy.cta;
    rootNode.hidden = false;
  }

  function updatePreview(rootNode, doc) {
    const formId = rootNode.dataset.formId || "";
    const params = new URLSearchParams(doc.defaultView.location.search);
    const variantId = selectedVariantId(doc, formId, rootNode.dataset.variantId);
    const offer = resolveOffer(params, rootNode.dataset.productId, variantId);
    rootNode.hidden = !offer;
    doc.body.classList.toggle("byloro-offer-active", Boolean(offer));
    updateOfferPromotionalSuppressions(offer, doc);
    if (!offer) {
      const button = offerPurchaseButton(rootNode, doc);
      const previousOffer = OFFER_CATALOG[rootNode.dataset.offerId || params.get("offer") || ""] ||
        Object.values(OFFER_CATALOG).find(candidate => normalizeId(rootNode.dataset.productId) === candidate.qualifying.productId);
      const previousCopy = localized(previousOffer && previousOffer.customerText, rootNode.dataset.locale || doc.documentElement.lang || "nl") || {};
      if (button && nativePurchaseMarkup.has(button)) {
        if ([previousCopy.cta, previousCopy.ctaWithoutGift, previousCopy.replaceGift, previousCopy.addingCta].includes(button.textContent)) button.innerHTML = nativePurchaseMarkup.get(button);
        nativePurchaseMarkup.delete(button);
      }
      const form = doc.getElementById(rootNode.dataset.formId || "");
      const { wrapper, input } = retainedIndyPersonalizationControls(rootNode);
      const propertyName = previousOffer && normalizeId(rootNode.dataset.productId) === previousOffer.qualifying.productId && previousOffer.qualifying.personalization.propertyName;
      if (form && wrapper && input && propertyName) {
        syncIndyPersonalization(rootNode, previousOffer, doc);
        const canonical = findCanonicalProductPropertyField(rootNode, form, propertyName);
        if (canonical && rootNode.dataset.personalizationConflict && canonical.dataset.byloroClosingValidation !== "true") {
          canonical.setCustomValidity(previousCopy.personalizationConflict);
          canonical.dataset.byloroClosingValidation = "true";
          const acknowledgeNativeEdit = event => {
            if (!event.isTrusted) return;
            input.value = "";
            canonical.setCustomValidity("");
            delete rootNode.dataset.personalizationConflict;
            canonical.removeEventListener("input", acknowledgeNativeEdit);
          };
          canonical.addEventListener("input", acknowledgeNativeEdit);
        }
        if (!canonical || rootNode.dataset.personalizationConflict) {
          input.name = "properties[" + propertyName + "]";
          input.disabled = false;
          input.required = true;
          wrapper.hidden = false;
          if (button && button.parentNode === form) form.insertBefore(wrapper, button);
          else form.append(wrapper);
        }
      }
      if (!propertyName) syncIndyPersonalization(rootNode, null, doc);
      suppressConflictingAnnouncements({ suppressAnnouncementText: [] }, doc);
      delete rootNode.dataset.offerId;
      delete rootNode.dataset.offerVersion;
      delete rootNode.dataset.attributionContext;
      return;
    }

    rootNode.dataset.offerId = offer.id;
    rootNode.dataset.offerVersion = offer.version;
    rootNode.dataset.attributionContext = JSON.stringify(getAttributionContext(params));
    syncIndyPersonalization(rootNode, offer, doc);
    suppressConflictingAnnouncements(offer, doc);
    renderOffer(rootNode, offer, doc);
  }

  function mount(doc) {
    if (!doc || mountedDocuments.has(doc)) return;
    mountedDocuments.add(doc);
    const components = [...doc.querySelectorAll("[data-byloro-offer-flow]")];
    const cartMarker = doc.querySelector("[data-byloro-cart-state]");
    if (cartMarker && OFFER_CATALOG[cartMarker.dataset.byloroCartState]) mountCartLifecycle(doc, OFFER_CATALOG[cartMarker.dataset.byloroCartState]);
    else if (doc.defaultView.themeVariables?.settings.pageType === "cart" && isPreviewTheme(OFFER_CATALOG.indy_gift_v1, doc)) mountCartLifecycle(doc, OFFER_CATALOG.indy_gift_v1);
    if (!components.length) return;

    const reconcile = () => components.forEach(component => updatePreview(component, doc));
    reconcile();
    components.forEach(component => {
      const button = offerPurchaseButton(component, doc);
      doc.addEventListener("submit", event => {
        if (event.target.tagName !== "FORM" || event.target.getAttribute("id") !== component.dataset.formId || !event.target.closest(".shopify-section")?.contains(component)) return;
        if (!component.dataset.offerId) {
          const nativeForm = doc.getElementById(component.dataset.formId || "");
          if (nativeForm && event.target !== nativeForm) {
            event.preventDefault();
            event.stopImmediatePropagation();
            nativeForm.requestSubmit();
          } else {
            const closedOffer = Object.values(OFFER_CATALOG).find(offer => normalizeId(component.dataset.productId) === offer.qualifying.productId);
            if (closedOffer && normalizeId(component.dataset.productId) === closedOffer.qualifying.productId) {
              const nativeMirror = nativeForm.querySelector("[data-byloro-native-personalization]");
              if (nativeMirror) nativeMirror.disabled = true;
              const resolved = resolveIndyPersonalization(component, nativeForm, closedOffer, doc, doc.defaultView.FormData);
              const copy = localized(closedOffer.customerText, component.dataset.locale || doc.documentElement.lang || "nl");
              if (resolved.conflict || !resolved.value.trim()) {
                event.preventDefault();
                event.stopImmediatePropagation();
                if (resolved.field) {
                  resolved.field.setCustomValidity(resolved.conflict ? copy.personalizationConflict : copy.missingIndyPersonalization);
                  resolved.field.dataset.byloroClosingValidation = "true";
                  resolved.field.reportValidity();
                }
                return;
              }
              const propertyInputName = "properties[" + resolved.propertyName + "]";
              for (const field of nativeForm.elements) {
                if (field !== nativeMirror && field.name === propertyInputName && !field.matches(":disabled") &&
                    field.type !== "file" && typeof field.value === "string" && !field.value.trim()) {
                  field.value = resolved.value;
                  nativePersonalizationCopies.set(field, resolved.value);
                }
              }
              if (!readProductPropertyValues(nativeForm, doc.defaultView.FormData, resolved.propertyName).length) {
                const mirror = nativeMirror || doc.createElement("input");
                mirror.type = "hidden";
                mirror.name = propertyInputName;
                mirror.value = resolved.value;
                mirror.disabled = false;
                mirror.dataset.byloroNativePersonalization = "true";
                if (!nativeMirror) nativeForm.appendChild(mirror);
              }
            }
            if (!event.target.reportValidity()) {
              event.preventDefault();
              event.stopImmediatePropagation();
            }
          }
          return;
        }
        event.preventDefault();
        event.stopImmediatePropagation();
        addOfferToCart(component, doc);
      }, true);

      const form = doc.getElementById(component.dataset.formId || "");
      const section = form && (form.closest(".shopify-section") || form.parentElement);
      const offer = OFFER_CATALOG[component.dataset.offerId || ""] ||
        Object.values(OFFER_CATALOG).find(candidate => normalizeId(component.dataset.productId) === candidate.qualifying.productId);
      const propertyName = offer && offer.qualifying && offer.qualifying.personalization && offer.qualifying.personalization.propertyName;
      const Observer = doc.defaultView && doc.defaultView.MutationObserver;
      if (!section || !propertyName || !Observer) return;
      let reconcileQueued = false;
      const observer = new Observer(records => {
        const expectedName = "properties[" + propertyName + "]";
        const hasExternalProperty = node => {
          if (!node || node.nodeType !== 1) return false;
          const fields = [];
          if (node.matches && node.matches("[name]")) fields.push(node);
          if (node.querySelectorAll) fields.push(...node.querySelectorAll("[name]"));
          const fallback = retainedIndyPersonalizationControls(component).input;
          return fields.some(field => field.name === expectedName && field !== fallback &&
            !field.hasAttribute("data-byloro-native-personalization") && !component.contains(field));
        };
        const relevant = records.some(record => {
          if (record.type === "attributes") return hasExternalProperty(record.target);
          return [...record.addedNodes, ...record.removedNodes].some(hasExternalProperty);
        });
        if (!relevant || reconcileQueued) return;
        reconcileQueued = true;
        root.requestAnimationFrame(() => {
          reconcileQueued = false;
          reconcile();
        });
      });
      observer.observe(section, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ["name", "disabled", "hidden", "style"]
      });
    });
    doc.addEventListener("input", event => {
      for (const component of components) {
        if (!component.dataset.offerId) {
          const closedOffer = Object.values(OFFER_CATALOG).find(offer => normalizeId(component.dataset.productId) === offer.qualifying.productId);
          if (closedOffer && event.target.name === "properties[" + closedOffer.qualifying.personalization.propertyName + "]") {
            const section = component.closest(".shopify-section");
            for (const field of section?.querySelectorAll('[data-byloro-closing-validation="true"]') || []) {
              field.setCustomValidity("");
              delete field.dataset.byloroClosingValidation;
            }
            root.requestAnimationFrame(reconcile);
          }
        }
        const offer = OFFER_CATALOG[component.dataset.offerId || ""];
        if (offer && event.target.name === "properties[" + offer.qualifying.personalization.propertyName + "]") {
          syncIndyPersonalization(component, offer, doc);
          const status = component.querySelector("[data-offer-status]");
          const copy = localized(offer.customerText, component.dataset.locale || doc.documentElement.lang || "nl");
          if (!component.dataset.personalizationConflict && event.target.value.trim() && status &&
              [copy.missingIndyPersonalization, copy.personalizationConflict].includes(status.textContent)) setOfferStatus(component, "", false);
        }
      }
    });
    doc.addEventListener("change", event => {
      const picker = event.target.closest && event.target.closest("variant-picker[form]");
      const pickerFormId = picker && picker.getAttribute("form");
      const changedProductForm = components.some(component => {
        const formId = component.dataset.formId || "";
        const form = formId && doc.getElementById(formId);
        return pickerFormId === formId || (form && form.contains(event.target));
      });
      if (changedProductForm) root.requestAnimationFrame(reconcile);
    }, true);
  }

  const api = {
    catalog: OFFER_CATALOG,
    resolveOffer,
    isWithinWindow,
    getAttributionContext,
    buildOrderReport,
    buildOfferUrl,
    getGiftFieldOptions,
    resolveGiftVariant,
    buildCartItems,
    cartHasOffer,
    cartHasConflictingOfferLines,
    readProductProperties,
    discountForVariant,
    discountMode,
    personalizationTransfer,
    campaignState,
    ordinaryCodes,
    cartCodes,
    cartRecoveryMatches,
    restoreCampaignCart,
    verifyGiftAllocation,
    hasIncompatiblePromotion,
    sameExistingCartLines,
    reconcileCampaignCart,
    applyCampaignCode,
    syncIndyPersonalization,
    resolveIndyPersonalization,
    routeMarkedGiftLinks,
    removeFlowLines,
    withCartLock,
    addOfferToCart,
    clearGiftInputStatus,
    mountCartLifecycle,
    mount
  };
  root.BYLORO_OFFER_FLOW = api;
  if (typeof module !== "undefined" && module.exports) module.exports = api;

  if (root.document) {
    if (root.document.readyState === "loading") {
      root.document.addEventListener("DOMContentLoaded", () => mount(root.document), { once: true });
    } else {
      mount(root.document);
    }
  }
})(typeof window !== "undefined" ? window : globalThis);
